import { render, staticRenderFns } from "./bindDi.vue?vue&type=template&id=18d351a8&scoped=true"
import script from "./bindDi.vue?vue&type=script&lang=js"
export * from "./bindDi.vue?vue&type=script&lang=js"
import style0 from "./bindDi.vue?vue&type=style&index=0&id=18d351a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d351a8",
  null
  
)

export default component.exports